import { useCallback, useEffect, useState } from 'react';

type Currency = 'GC' | 'SC';
const LOCAL_STORAGE_KEY = 'currency';

export const useCurrency = () => {
  const [currency, setCurrency] = useState<Currency>(() => {
    if (typeof window !== 'undefined') {
      return (localStorage.getItem(LOCAL_STORAGE_KEY) as Currency) || 'SC';
    }
    return 'SC';
  });

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === LOCAL_STORAGE_KEY && event.newValue) {
        setCurrency(event.newValue as Currency);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const updateCurrency = useCallback((newCurrency: Currency) => {
    localStorage.setItem(LOCAL_STORAGE_KEY, newCurrency);
    setCurrency(newCurrency);

    window.dispatchEvent(
      new StorageEvent('storage', {
        key: LOCAL_STORAGE_KEY,
        newValue: newCurrency,
      }),
    );
  }, []);

  return { currency, setCurrency: updateCurrency };
};
